import { Calendar, MapPin, Sparkles } from 'lucide-react'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import type { EventDetails as EventDetailsType } from '@/types/seatingPlanner'

type EventDetailsProps = {
  event: EventDetailsType
  onChange: (patch: Partial<EventDetailsType>) => void
}

export default function EventDetails({ event, onChange }: EventDetailsProps) {
  return (
    <div className="grid gap-3 rounded-xl border border-black/5 bg-white p-3 shadow-sm sm:grid-cols-3">
      <div className="space-y-1">
        <Label htmlFor="event-name" className="flex items-center gap-1.5 text-xs font-medium text-muted-foreground">
          <Sparkles className="size-3.5" />
          Event name
        </Label>
        <Input
          id="event-name"
          placeholder="e.g. Spring Charity Gala 2026"
          value={event.name}
          onChange={(e) => onChange({ name: e.target.value })}
        />
      </div>
      <div className="space-y-1">
        <Label htmlFor="event-date" className="flex items-center gap-1.5 text-xs font-medium text-muted-foreground">
          <Calendar className="size-3.5" />
          Date
        </Label>
        <Input
          id="event-date"
          type="date"
          value={event.date}
          onChange={(e) => onChange({ date: e.target.value })}
        />
      </div>
      <div className="space-y-1">
        <Label htmlFor="event-venue" className="flex items-center gap-1.5 text-xs font-medium text-muted-foreground">
          <MapPin className="size-3.5" />
          Venue
        </Label>
        <Input
          id="event-venue"
          placeholder="e.g. The Grand Ballroom, NYC"
          value={event.venue}
          onChange={(e) => onChange({ venue: e.target.value })}
        />
      </div>
    </div>
  )
}
